export default __webpack_public_path__ + "static/media/296.1c493b6a.png";